<main class="flex flex-col gap-6">
    <div class="w-[15rem]">
        <app-segment [(value)]="segment" [options]="segments" />
    </div>
    <app-ssp-data-grid
        [options]="options"
        [columns]="cols"
        [(page)]="pageNo"
        [(pageSize)]="pageSize"
        [(query)]="query"
        [(align)]="align"
        [(orderBy)]="orderBy"
        [rowData]="items()"
        [pageInfo]="pageInfo()!"
    >
        <div buttons class="flex gap-2 items-center">
            <app-button (click)="handleManageCategory()" variant="outline"
                >카테고리 관리</app-button
            >
            <app-button [routerLink]="['/store/form', _type()]"
                >등록</app-button
            >
        </div>
    </app-ssp-data-grid>
</main>
